<template>
    <div class="w-100">
        <div class="card">
            <div class="card-header bg-primary text-white">
                <page-title :title="$t('company.title')"></page-title>
            </div>
            <div class="btn-toolbar justify-content-between mt-3" role="toolbar">
                <div class="form-inline col-lg-6 col-md-12"></div>

                <div class="input-group col-lg-6 col-md-12">
                    <input v-model="searchQuery"
                           v-on:keyup.enter.stop="massSearch"
                           v-on:keyup.esc.stop="clearFilters"
                           type="text"
                           class="form-control"
                           aria-label="Mass search input"
                           aria-describedby="massSearch" />
                    <button class="btn btn-secondary" @click.stop="massSearch">
                        <i class="fas fa-search"></i>
                        {{ $t('buttons.search.btnText') }}
                    </button>
                    <button class="btn btn-secondary" @click.stop="clearFilters">
                        <i class="fas fa-times"></i>
                        {{ $t('buttons.clearFilters.btnText') }}
                    </button>
                </div>
            </div>

            <div class="card-body">
                <div class="grid-wrapper">
                    <kendo-datasource ref="datasource"
                                      :transport="transportSettings"
                                      :schema-model-id="'id'"
                                      :schema-model-fields="schemaModelFields"
                                      :schema-total="'total'"
                                      :schema-data="'data'"
                                      :page-size='defaultGridRows'
                                      :server-paging="true"
                                      :server-sorting="true"
                                      :server-filtering="true"
                                      :error="dataSourceError"
                                      :requestEnd="datasorceRequestEnd">
                    </kendo-datasource>

                    <kendo-grid ref="grid"
                                :data-source-ref="'datasource'"
                                :pageable="gridOptions.pageable"
                                :navigatable="gridOptions.navigatable"
                                :editable="gridOptions.editable"
                                :filterable="gridOptions.filterable"
                                :reorderable="gridOptions.reorderable"
                                :resizable="gridOptions.resizable"
                                :groupable="gridOptions.groupable"
                                :allow-copy="gridOptions.allowCopy"
                                :column-menu="gridOptions.columnMenu"
                                :sortable-mode="gridOptions.sortable.mode"
                                :sortable-allow-unsort="gridOptions.sortable.allowUnsort"
                                :sortable-show-indexes="gridOptions.sortable.showIndexes"
                                :selectable="gridOptions.selectable"
                                :scrollable="gridOptions.scrollable"
                                :dataBound="dataBound">
                        <kendo-grid-column :field="'id'"
                                           :title="$t('company.id')"
                                           :width="100">
                        </kendo-grid-column>
                        <kendo-grid-column v-if="hasUpdateRights"
                                           field="btnsColumn"
                                           :title="' '"
                                           :filterable="false"
                                           :sortable="false"
                                           :template="btnsTemplate"
                                           :width="100">
                        </kendo-grid-column>
                        <kendo-grid-column :field="'name'"
                                           :width="250"
                                           :title="$t('company.name')">
                        </kendo-grid-column>
                        <kendo-grid-column :field="'vatNumber'"
                                           :width="150"
                                           :title="$t('company.vatNumber')">
                        </kendo-grid-column>
                        <kendo-grid-column :field="'bulstatUic'"
                                           :width="150"
                                           :title="$t('company.bulstatUic')">
                        </kendo-grid-column>
                        <kendo-grid-column :field="'phone'"
                                           :width="150"
                                           :title="$t('company.phone')">
                        </kendo-grid-column>
                        <kendo-grid-column :field="'fax'"
                                           :width="150"
                                           :title="$t('company.fax')">
                        </kendo-grid-column>
                        <kendo-grid-column :field="'email'"
                                           :width="200"
                                           :title="$t('company.email')">
                        </kendo-grid-column>
                        <kendo-grid-column :field="'description'"
                                           :width="250"
                                           :title="$t('company.description')">
                        </kendo-grid-column>
                        <!--<kendo-grid-column :field="'creatorUsername'"
                                           :title="$t('company.createdBy')"
                                           :width="150">
                        </kendo-grid-column>
                        <kendo-grid-column :field="'createdAt'"
                                           :title="$t('company.createdAt')"
                                           :width="150"
                                           :format="customDateTimeLongFormat">
                        </kendo-grid-column>
                        <kendo-grid-column :field="'creatorUsername'"
                                           :title="$t('company.updatedBy')"
                                           :width="150">
                        </kendo-grid-column>
                        <kendo-grid-column :field="'updaterUsername'"
                                           :title="$t('company.updatedAt')"
                                           :width="150"
                                           :format="customDateTimeLongFormat">
                        </kendo-grid-column>-->
                    </kendo-grid>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';
    import PageTitle from '../../components/common/PageTitle';
    import BtnsTemplate from "../../components/grid/StandardBtnsTemplate";
    import { mapGetters } from 'vuex'

    export default {
        components: {
            PageTitle,
            BtnsTemplate,
        },
        data() {
            return {
                searchQuery: '',
                defaultGridRows: this.$store.getters.defaultGridRows,
                schemaModelFields: {
                    id: { name: 'id', from: 'id', type: 'number', editable: false, nullable: false, visible: false },
                    name: { name: 'name', from: 'name', type: 'string', editable: true, nullable: true, visible: true },
                    vatNumber: { name: 'vatNumber', from: 'vatNumber', type: 'string', editable: false, nullable: true, visible: true },
                    bulstatUIC: { name: 'bulstatUIC', from: 'bulstatUIC', type: 'string', editable: false, nullable: true, visible: true },
                    phone: { name: 'phone', from: 'phone', type: 'string', editable: false, nullable: true, visible: true },
                    fax: { name: 'fax', from: 'fax', type: 'string', editable: false, nullable: true, visible: true },
                    url: { name: 'url', from: 'url', type: 'string', editable: false, nullable: true, visible: true },
                    email: { name: 'email', from: 'email', type: 'string', editable: false, nullable: true, visible: true },
                    description: { name: 'description', from: 'description', type: 'string', editable: false, nullable: true, visible: true },
                    creatorUsername: { name: 'creatorUsername', from: 'creatorUsername', type: 'string', editable: false, nullable: true, visible: true },
                    updaterUsername: { name: 'updaterUsername', from: 'updaterUsername', type: 'string', editable: false, nullable: true, visible: true },
                    createdAtUtc: { name: 'createdAtUtc', from: 'createdAtUtc', type: 'date', editable: false, nullable: true, visible: true },
                    updatedAtUtc: { name: 'updatedAtUtc', from: 'updatedAtUtc', type: 'date', editable: false, nullable: true, visible: true },
                    deactivated: { name: 'deactivated', from: 'deactivated', type: 'boolean', editable: true, nullable: true, visible: true },
                },
                transportSettings: {
                    read: {
                        url: this.$store.getters.baseUrl + '/api/company/list',
                        dataType: 'json',
                        type: 'POST',
                        contentType: 'application/json',
                        beforeSend: this.beforeSend
                    },
                    parameterMap: this.parameterMap
                }
            };
        },
        methods: {
            dataBound(e) { },
            datasorceRequestEnd(e) { },
            dataSourceError(e) {
                this.$vs.notify({
                    title: this.$t('notifications.error'),
                    text: this.$helpers.kendoDataSourceErrorText(e),
                    color: 'danger',
                    time: this.$store.getters.notificationDuration,
                });
            },
            parameterMap: function (options, operation) {
                if (operation !== 'read' && options.models) {
                    return { models: kendo.stringify(options.models) };
                } else {
                    return kendo.stringify(options);
                }
            },
            beforeSend: function (req) {
                if (this.token) {
                    req.setRequestHeader('Authorization', 'Bearer ' + this.token);
                }
            },
            isDeactivatedTemplate: function (dataItem) {
                let templateHtml =
                    '<div class="text-center"><span class="badge ' + (dataItem.deactivated ? 'badge-danger' : 'badge-success') + '">' + kendo.htmlEncode(dataItem.deactivated ? this.$t('yes') : this.$t('no')) + '</span></div>';

                return templateHtml;
            },
            refresh() {
                let grid = this.$refs.grid;
                if (grid) {
                    grid.kendoWidget().dataSource.read();
                }
            },
            clearFilters() {
                this.searchQuery = '';
                const grid = this.$refs.grid.kendoWidget();
                if (grid) {
                    grid.dataSource.sort({});
                    grid.dataSource.page(1);
                    grid.dataSource.aggregate([]);
                    grid.dataSource.filter({});
                }
            },
            massSearch() {
                if (!this.searchQuery) {
                    this.$vs.notify({
                        title: this.$t('buttons.search.btnText'),
                        text: this.$t('emptySearchFilter'),
                        color: 'warning',
                        time: this.$store.getters.notificationDuration
                    })

                    return;
                }

                let grid = this.$refs.grid.kendoWidget();
                if (grid) {
                    let filter = this.$helpers.getMassFilterForGrid(grid, this.searchQuery);
                    if (filter) {
                        grid.dataSource.filter(filter);
                    }
                }
            },
            btnsTemplate: function (e) {
                return {
                    template: Vue.component(BtnsTemplate.name, BtnsTemplate),
                    templateArgs: {
                        ...e,
                        parentComponent: this.$refs.participantsGrid,
                        btns: [
                            {
                                name: "companyEdit",
                                text: "",
                                tooltip: this.$t('buttons.edit.btnText'),
                                class: 'btn btn-primary',
                                icon: "far fa-edit",
                                show: this.hasUpdateRights,
                                clickHandler: this.editBtnClick
                            },
                            {
                                name: "companyEditNoValidation",
                                text: "",
                                tooltip: this.$t('buttons.editWithNoValidation.btnText'),
                                class: 'btn btn-primary',
                                icon: "far fa-edit",
                                show: this.hasUpdateRights,
                                clickHandler: this.editBtnClickSkipValidation
                            }
                        ]
                    }
                }
            },
            editBtnClick(args) {
                if (!this.hasUpdateRights) {
                    return this.$router.push(`/unauthorized`);
                }

                this.$router.push(`/company/${args.id}/edit?skipValidation=${false}`);
            },
            editBtnClickSkipValidation(args) {
                if (!this.hasUpdateRights) {
                    return this.$router.push(`/unauthorized`);
                }

                this.$router.push(`/company/${args.id}/edit?skipValidation=${true}`);
            },
        },
        computed: {
            ...mapGetters(['gridOptions', 'claims', 'dateTimeLongFormat']),
            hasUpdateRights() {
                return this.claims.nomenclatureTypes.update;
            },
            token: function () {
                return this.$store.getters.authToken;
            },
            customDateTimeLongFormat() {
                return `{0: ${this.dateTimeLongFormat} }`;
            },
        }
    };
</script>

<style>
</style>
